module.exports = __webpack_public_path__ + "static/img/Ten of Cups.912a58d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Ten of Cups.jpg
// module id = 1304
// module chunks = 0